import React from 'react'
import styled from 'styled-components'
import { ButtonGradientFilled } from '../../Button'
import { useFormikContext } from 'formik'
import {
  _captchaToken,
  _isChallengeRequired,
} from '../../../constants/recaptcha'

const SubmitButtonStyled = styled(ButtonGradientFilled)`
  height: 48px;
  font-weight: 600;
  font-family: inherit;
`

const SubmitButton = ({ handleSubmit }) => {
  const { dirty, isValid, isSubmitting, values } = useFormikContext()
  const isChallengeRequired = values[_isChallengeRequired]
  const captchaToken = values[_captchaToken]
  const disabled =
    !isValid || !dirty || isSubmitting || (isChallengeRequired && !captchaToken)

  return (
    <SubmitButtonStyled
      onClick={handleSubmit}
      type="submit"
      disabled={disabled}
    >
      Submit application
    </SubmitButtonStyled>
  )
}

export default SubmitButton
